// =====================================================
// お気に入り一覧: 見積もり対象チェックボックスの選択件数表示
// =====================================================
const favoriteQuoteCheckboxes = document.querySelectorAll( ".js-favorite-quote-checkbox" );
const favoriteQuoteSelectedCount = document.querySelector( ".js-favorite-quote-selected" );

function updateFavoriteQuoteSelectedCount ()
{
    if ( !favoriteQuoteSelectedCount )
    {
        return;
    }

    favoriteQuoteSelectedCount.textContent = document.querySelectorAll( ".js-favorite-quote-checkbox:checked" ).length;
}

favoriteQuoteCheckboxes.forEach( ( checkbox ) =>
{
    checkbox.addEventListener( "change", () =>
    {
        const card = checkbox.closest( ".js-favorite-card" );
        if ( card )
        {
            card.classList.toggle( "is-active", checkbox.checked );
        }

        updateFavoriteQuoteSelectedCount();
    } );
} );

updateFavoriteQuoteSelectedCount();

document.addEventListener( "favorite:removed", updateFavoriteQuoteSelectedCount );

// =====================================================
// お気に入り一覧: 選択した商品をLINEへの見積もりメッセージにして送る
// =====================================================
const favoriteLineQuoteButton = document.querySelector( ".js-favorite-line-quote" );

if ( favoriteLineQuoteButton )
{
    favoriteLineQuoteButton.addEventListener( "click", () =>
    {
        // チェック済みの商品名を集めて、LINEに送るメッセージ文を組み立てる
        const checkedCheckboxes = Array.from( document.querySelectorAll( ".js-favorite-quote-checkbox:checked" ) );

        const checkedProductNames = checkedCheckboxes
            .map( ( checkbox ) =>
            {
                const title = checkbox.closest( ".p-products-card" )?.querySelector( ".p-products-card__title" );
                const name = title ? title.textContent.trim() : "";
                return name ? `${ name }（ID:${ checkbox.value }）` : "";
            } )
            .filter( ( name ) => name !== "" );

        if ( !checkedProductNames.length )
        {
            window.alert( "見積もりを希望する商品を選択してください。" );
            return;
        }

        // LINEへの遷移は待たせず、記録はバックグラウンドで（keepalive: trueでページ遷移後も送信を継続させる）
        const ajaxConfig = window.podFavorite;
        if ( ajaxConfig )
        {
            const formData = new FormData();
            formData.append( "action", "log_favorite_quote_line" );
            formData.append( "nonce", ajaxConfig.quoteLogNonce );
            checkedCheckboxes.forEach( ( checkbox ) => formData.append( "product_ids[]", checkbox.value ) );

            fetch( ajaxConfig.ajaxUrl, {
                method: "POST",
                credentials: "same-origin",
                keepalive: true,
                body: formData,
            } ).catch( () => {} );
        }

        // LINE公式アカウントのトークに、選択商品名入りのメッセージを添えて遷移する
        const lineAccount = favoriteLineQuoteButton.dataset.lineAccount;
        const message = `下記の商品の見積もりを希望します。\n${ checkedProductNames.join( "、" ) }`;

        window.location.href = `https://line.me/R/oaMessage/${ lineAccount }/?${ encodeURIComponent( message ) }`;
    } );
}
